import quickFetch from 'quick-fetch';
import isEqual from 'hs-lodash/isEqual';
import { parseUrl } from 'hub-http/helpers/url';
import { stringify, parse } from 'hub-http/helpers/params';
import { OBJECT_TYPES } from 'automation-ui-canvas/constants/EarlyRequesterRequestNames';
export const isRequestEqualToEarlyRequest = (request, earlyRequest) => {
  // `request` and `earlyRequest` are going to have different structures that are parsed differently

  // `stringify` fails in IE 11 when the parameter is a number
  let requestStringifiedQueryParams = {};
  if (typeof request !== 'number') {
    // `stringify` is applied to ensure properties are all strings like the `earlyRequest`'s properties
    requestStringifiedQueryParams = parse(stringify(request));
  }
  const earlyRequestQueryParams = parse(parseUrl(earlyRequest.request.responseURL).query);

  // `requestStringifiedQueryParams` is looped through since it might not have standard params that are appended from `hub-http` (i.e. `clienttimeout`, `portalId`, etc.)
  return Object.keys(requestStringifiedQueryParams).every(key => isEqual(requestStringifiedQueryParams[key], earlyRequestQueryParams[key]));
};
export function fetchWithEarlyRequestHook(fallbackFetch, requestName, requestEntity) {
  const earlyRequest = quickFetch.getRequestStateByName(requestName);
  if (earlyRequest) {
    // check if the request params are equal to the early-request params
    if (requestEntity && !isRequestEqualToEarlyRequest(requestEntity, earlyRequest)) {
      return fallbackFetch();
    }
    return new Promise((resolve, reject) => {
      earlyRequest.whenFinished(result => {
        resolve(result);
        if (![OBJECT_TYPES].includes(requestName)) {
          quickFetch.removeEarlyRequest(requestName);
        }
      });
      earlyRequest.onError((xhr, errorMsg) => {
        const error = new Error(`Early request failure (${requestName}): ${errorMsg}`);
        error.info = xhr.response;
        error.status = xhr.status;
        reject(error);
        quickFetch.removeEarlyRequest(requestName);
      });
    });
  }
  return fallbackFetch();
}